
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13071',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13071",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "data-fetching-client": "static-1.9887",
  "foundations-components": "static-1.8357",
  "foundations-components-legacy": "static-1.1382",
  "foundations-theming": "static-1.4683",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.85",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8255",
  "hub-http-shared-msw-handlers": "static-1.10495",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11711",
  "I18n": "static-7.1655",
  "jasmine-runner": "static-1.6678",
  "marketplace-discovery-studio-lib": "static-1.519",
  "marketplace-storefront-base": "static-1.13134",
  "quartz": "static-1.7340",
  "react-dlb": "static-1.84",
  "react-rhumb": "static-1.16936",
  "reactive-variable-buffer-atom": "static-1.3085",
  "reporting-testing-lib": "static-1.10437",
  "reselect": "static-3.8",
  "settings-ui-lib": "static-1.12750",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7531",
  "ui-addon-i18n": "static-1.11376",
  "ui-addon-react-router-dom": "static-1.9763",
  "unified-auth": "static-1.767",
  "unified-auth-core-lib": "static-1.1049",
  "usage-tracker": "static-1.7587",
  "usage-tracker-core": "static-1.7437",
  "customer-data-property-utils": "static-1.8327",
  "hub-http": "static-1.6443",
  "integrations-lib": "static-1.16879",
  "marketplace-ui-common": "static-1.20523",
  "marketplace-ui-install": "static-1.509",
  "property-management-iframe": "static-1.13923",
  "quartz-config": "static-1.1118",
  "quartz-core": "static-1.6559",
  "quartz-routing": "static-1.770",
  "quick-fetch": "static-1.4077",
  "react": "static-7.190",
  "rpc-client-utils": "static-1.4892",
  "ts-schema": "static-1.4239",
  "ui-universal-auth": "static-1.9253",
  "UIComponents": "static-3.8657",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3561",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3617",
  "quartz-webpack": "static-1.3564",
  "bend-plugin-quartz-routing": "static-1.418",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4626",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5105",
  "foundations-theming-specialty": "static-1.2399",
  "framer-motion": "static-1.75",
  "hs-story-utils": "static-1.9656",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.55",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5501",
  "react-virtualized": "static-2.103",
  "StyleGuideUI": "static-3.492",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2413",
  "ui-fonts": "static-1.973",
  "ui-images": "static-2.1223",
  "bend-plugin-foundations-theming": "static-1.3166",
  "foundations-theming-base": "static-1.3668",
  "stylex": "static-1.37",
  "HeadJS": "static-2.785",
  "hs-test-utils-bend-plugin": "static-1.3366",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4548",
  "ui-addon-video-player": "static-1.8936",
  "ai-components-ui-library": "static-1.9544",
  "ai-rendering-library": "static-1.10961",
  "chirp-fetch": "static-1.2117",
  "connections-embed-lib": "static-1.1408",
  "copilot-toolkit": "static-1.11709",
  "feedback-loader": "static-1.29706",
  "laboratory-lib": "static-3.7381",
  "marketplace-embed": "static-1.22775",
  "marketplace-ui-details": "static-1.10418",
  "marketplace-ui-reviews": "static-1.20478",
  "marketplace-ui-tracking": "static-1.14693",
  "sanitize-text": "static-1.8378",
  "usage-tracker-multi": "static-1.6001",
  "usage-tracker-session-replay": "static-1.5273",
  "wootric-nps": "static-1.7146",
  "quartz-head": "static-1.1005",
  "web-vitals": "static-1.9",
  "apollo-link-hub-http": "static-2.4887",
  "immer": "static-1.94",
  "immerable": "static-1.4381",
  "highcharts": "static-8.107",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2635",
  "reporting-data": "static-1.68504",
  "cssUtils": "static-1.862",
  "flux-actions": "static-1.357",
  "HubStyle": "static-2.12018",
  "PatternValidationJS": "static-1.3126",
  "react-colorpicker": "static-2.10437",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.71",
  "ReduxMessenger": "static-2.10595",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7577",
  "icons": "static-2.672",
  "marketplace-ui-apps-core": "static-1.19055",
  "storybook-react": "static-1.36",
  "trellis-story-utils": "static-1.4740",
  "foundations-components-test-utils": "static-1.5840",
  "quartz-i18n": "static-1.1015",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.314",
  "ads-unified-auth-lib": "static-1.891",
  "google-sheets-integration-lib": "static-1.893",
  "microsoft-drive-integration-lib": "static-1.1037",
  "surveymonkey-integration-lib": "static-1.337",
  "slack-ui-library": "static-1.10625",
  "fsm": "static-1.3967",
  "customer-data-objects": "static-1.7914",
  "property-translator": "static-1.5623",
  "hs-locale-management": "static-1.241",
  "frontend-preferences-client": "static-1.8158",
  "hs-promise-utils": "static-1.5825",
  "hubspot-apollo-client": "static-1.5107",
  "integrations-error-boundary-lib": "static-1.14294",
  "integrations-tracking-lib": "static-1.5838",
  "native-integrations-shared-strings": "static-1.8007",
  "sanitize": "static-1.4706",
  "superstore": "static-1.4986",
  "ui-shepherd-react": "static-3.10492",
  "ai-settings-ui-library": "static-1.8229",
  "hub-http-janus": "static-1.863",
  "hubspotter-http": "static-1.4809",
  "immutable-less": "static-1.4881",
  "marketplace-ui-client-types": "static-1.17930",
  "nav-meta": "static-1.30326",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18301",
  "ui-product-approvals-common": "static-1.851",
  "ai-studio-lib": "static-1.12304",
  "hubspot-prosemirror": "static-1.18852",
  "integrations-reconnect-lib": "static-1.381",
  "ui-addon-iframeable": "static-1.9306",
  "ui-addon-integrations-directory-panel": "static-2.8255",
  "ui-product-approvals": "static-1.28956",
  "ui-tool-access": "static-1.10383",
  "inbound-db-properties-service-client": "static-1.4005",
  "property-management-common": "static-1.6211",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.560",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1015",
  "quartz-test": "static-1.1015",
  "quartz-tracking": "static-1.719",
  "trellis-components": "static-1.2432",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.302",
  "bender-build-tools": "static-1.3356",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22543",
  "ContentUtils": "static-1.69019",
  "customer-data-objects-ui-components": "static-1.13261",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2727",
  "breeze-engine-core": "static-1.805",
  "breeze-onboarding-components": "static-1.579",
  "customer-data-filters-ui": "static-1.40692",
  "customer-data-reference-ui-components": "static-1.13408",
  "embedded-academy-lib": "static-1.15291",
  "ExportDialog": "static-6.10610",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41875",
  "reporting-snowflake": "static-1.57122",
  "reporting-ui-components": "static-2.65775",
  "reporting-visualizations": "static-1.60580",
  "trellis-theming": "static-1.1185",
  "ui-addon-teams": "static-1.21836",
  "upgrade-components-lib": "static-1.435",
  "magpie-lib": "static-1.5710",
  "navigation-components": "static-1.18689",
  "breeze-engine-lib": "static-1.1527",
  "magpie-types": "static-1.5170",
  "simple-logging-lib": "static-1.3279",
  "fail-safe": "static-1.180",
  "app-governance-lib": "static-1.2254",
  "developer-experience-shared-components": "static-1.10728",
  "purchase-motions-components": "static-1.6263",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.9930",
  "usage-tracker-anonymous": "static-1.6004",
  "usage-tracker-public": "static-1.7398",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3931",
  "reference-resolvers": "static-1.8412",
  "ui-extensibility-client-types": "static-1.4150",
  "hubspot-apollo-cache": "static-1.566",
  "universal-page-editor-lib": "static-1.3240",
  "final-form": "static-1.73",
  "redux-toolkit": "static-1.73",
  "simple-data-table": "static-1.3405",
  "atom": "static-1.5306",
  "merchandise-lib": "static-1.273",
  "salesImages": "static-1.530",
  "codemirror": "static-5.98",
  "react-codemirror": "static-1.10870",
  "ui-addon-draggable": "static-3.4986",
  "content-assistance-lib": "static-1.8107",
  "content-media-capture": "static-1.5245",
  "customer-data-ui-utilities": "static-1.10056",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24314",
  "growth-payments-core": "static-1.26035",
  "knowledge-content-types": "static-1.8614",
  "payment-link-components": "static-1.24044",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20209",
  "ui-addon-emoji-picker": "static-1.10116",
  "ui-business-units-lib": "static-1.9311",
  "video-components-external": "static-1.12008",
  "video-data-lib": "static-1.35666",
  "navigation-messaging": "static-1.8016",
  "collaboration-sidebar": "static-1.58566",
  "react-dnd-compat": "static-1.4845",
  "batch-promise": "static-1.1774",
  "crm-component-utils": "static-1.39698",
  "crm-properties-common-lib": "static-1.6119",
  "customer-data-properties": "static-1.52374",
  "external-options-client-types": "static-1.4286",
  "framework-data-schema-resolvers": "static-1.7123",
  "property-value-citations": "static-1.2988",
  "reference-resolvers-lite": "static-1.8329",
  "hubspotter-http-shared-msw-handlers": "static-1.10493",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "tanstack-virtual": "static-1.35",
  "cms-field-types": "static-1.5044",
  "content-icons-ui": "static-1.2297",
  "breeze-artifacts-sdk": "static-1.124",
  "onboarding-journeys-lib": "static-1.746",
  "pulse": "static-1.854",
  "conversations-skeleton-state": "static-1.7479",
  "crm-message-bus": "static-1.43593",
  "customer-data-filters-ui-msw-helpers": "static-1.23127",
  "events-data-lib": "static-1.473",
  "FormUrlGenerator": "static-2.4955",
  "framework-builder-read-service-client": "static-1.4167",
  "framework-data-schema-quick-fetch": "static-1.7028",
  "multi-account-reference-resolvers": "static-1.1227",
  "onboarding-tours": "static-1.17013",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14333",
  "academy-common-lib": "static-1.14751",
  "dashboard-lib": "static-1.82508",
  "getting-started-shared-tasks": "static-1.19074",
  "hubspot-prosemirror-plugins": "static-1.18844",
  "share-with-third-party-component-lib": "static-1.8934",
  "ui-asset-management-lib": "static-1.11319",
  "user-context": "static-1.5342",
  "reporting-plugins": "static-1.10671",
  "reporting-reports": "static-1.68182",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.950",
  "nest": "static-1.467",
  "breeze-engine-chat-components": "static-1.505",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.131",
  "framework-listing-lib": "static-2.29335",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31276",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4484",
  "onboarding-scopes": "static-1.6688",
  "purchase-motions-api": "static-1.6266",
  "signup-constants": "static-1.19456",
  "signup-ui-url-generator": "static-2.8288",
  "onboarding-tours-client": "static-1.5227",
  "one-click-checkout": "static-1.305",
  "platform-infra-nav-components": "static-1.7831",
  "subscription-experience-data-types": "static-1.15175",
  "crm-record-cards-service-types": "static-1.3740",
  "location-customization-utils-lib": "static-1.9953",
  "redux-thunk": "static-2.75",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.74",
  "ui-coaching-tips": "static-1.29178",
  "content-media-composition-data-lib": "static-1.13049",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4654",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.570",
  "ui-addon-opt": "static-4.8592",
  "commerce-tours-lib": "static-1.6508",
  "growth-onboarding-reliability": "static-1.5310",
  "sales-checkout-service-client": "static-1.3766",
  "data-token-picker": "static-1.16791",
  "FileManagerLib": "static-1.39954",
  "content-media-compositions": "static-2.17056",
  "media-bridge-lib": "static-1.19311",
  "chatspot-widget-iframe": "static-1.22534",
  "collaboration-sidebar-common": "static-1.3363",
  "marketing-platform-lib": "static-1.7098",
  "card-properties-lib": "static-1.44866",
  "commerce-subscription-lib": "static-1.37640",
  "crm-actions": "static-1.6580",
  "crm-cards-sdk": "static-1.44329",
  "customer-data-properties-shared-msw-handlers": "static-1.9822",
  "customer-data-tracking": "static-1.7112",
  "hs-resources": "static-1.418",
  "calling-global-api": "static-1.65302",
  "calling-internal-common": "static-1.31546",
  "calling-lifecycle-internal": "static-1.66684",
  "calling-lifecycle-messages": "static-1.58978",
  "commerce-products-lib": "static-1.10364",
  "conditional-properties-service-client": "static-1.3958",
  "crm-links": "static-1.6549",
  "crm-index-visualization-core": "static-1.4449",
  "crm-pipelines-api-client-types": "static-1.4295",
  "formula-editor": "static-1.14648",
  "google-libphonenumber": "static-1.41",
  "inbounddb-objects-service-types": "static-1.4372",
  "meetings-icalendar-utils-lib": "static-1.865",
  "multi-currency-client-types": "static-1.3852",
  "object-builder-ui-client": "static-1.49478",
  "pipeline-validation-client-types": "static-1.4127",
  "smart-property-lib": "static-1.8139",
  "tiered-pricing": "static-1.1830",
  "topics-actions-lib": "static-1.388",
  "ui-addon-form-validation": "static-1.11216",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.242",
  "bend-plugin-pulse": "static-1.357",
  "event-emitter": "static-1.1182",
  "fast-json-patch": "static-1.66",
  "restore-request-side-panel-lib": "static-1.1495",
  "growth-data-modal": "static-1.5792",
  "growth-onboarding-confetti": "static-1.3291",
  "growth-onboarding-next-action-utils": "static-1.2558",
  "onboarding-tours-utils": "static-1.1079",
  "ui-shepherd-tracker": "static-1.7873",
  "academy-service-client": "static-1.3920",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39813",
  "SafeStorage": "static-1.4633",
  "video-embed": "static-1.36500",
  "redux-actions": "static-3.67",
  "EmailSignatureEditor": "static-1.24882",
  "viral-links-lib": "static-1.7303",
  "nested-table": "static-1.464",
  "timezone-utils": "static-2.5476",
  "getting-started-shared-tasks-store": "static-1.18192",
  "campaign-roi-lib": "static-1.9946",
  "ui-addon-calendars": "static-2.5556",
  "customer-data-views-management": "static-1.25905",
  "framework-data-table": "static-2.12415",
  "nudge-client-utils": "static-1.3040",
  "nudge-custom-ui-functions": "static-1.1393",
  "switchboard-lib": "static-1.446",
  "access-check-ui-lib": "static-1.1446",
  "app-users-service-client": "static-1.5848",
  "app-users-service-types": "static-1.5256",
  "mini-checkout-client": "static-1.27400",
  "onboarding-utils": "static-1.5592",
  "permissions-shared-i18n-strings-fe": "static-1.2105",
  "ui-coaching-tips-shared-config": "static-1.29163",
  "checkout-sdk": "static-3.24243",
  "payment-method-components": "static-1.7077",
  "touchless-buying-components": "static-1.6111",
  "upgrade-catalog-service-types": "static-1.3715",
  "edison-service-client-types": "static-1.619",
  "growth-onboarding-feedback-components": "static-1.6812",
  "audio-components": "static-1.6249",
  "FileManagerImages": "static-1.37465",
  "video-components": "static-1.14010",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92700",
  "customer-data-sidebar": "static-2.46610",
  "enrichment-properties-lib": "static-1.17710",
  "ui-addon-draggable-compat": "static-2.4491",
  "universal-record-utils-lib": "static-1.1672",
  "commerce-billing-lib": "static-1.19901",
  "commerce-shared-components-lib": "static-1.19098",
  "commerce-tools-ui-lib": "static-1.10926",
  "crm-fe-perf": "static-1.23129",
  "calling-error-reporting": "static-1.31553",
  "shared-worker-versioning": "static-1.11269",
  "calling-usage-tracker": "static-1.6769",
  "voice-sms-access-library": "static-1.1823",
  "commerce-permissions": "static-1.1006",
  "products-iframe-lib": "static-1.8463",
  "products-ui-components-shared-msw-handlers": "static-1.10877",
  "crm-index-associations-lib": "static-1.6671",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10578",
  "sales-views-client-types": "static-1.4487",
  "bark-lib": "static-1.16735",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.546",
  "policy-lib": "static-1.7023",
  "react-tinymce": "static-1.55838",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10641",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54964",
  "tinymce-plugins": "static-1.58078",
  "tinymce-themes": "static-1.56934",
  "onboarding-data-sync-lib": "static-1.2362",
  "growth-onboarding-next-action-components": "static-1.2586",
  "user-context-client": "static-1.4754",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "urlinator": "static-1.4763",
  "outpost": "static-1.4392",
  "draft-convert": "static-2.76",
  "draft-extend": "static-3.79",
  "draft-js": "static-5.81",
  "draft-plugins": "static-2.22058",
  "sales-email-signature-service-client": "static-1.4075",
  "ts-utils-lib": "static-1.405",
  "crm-export-dialog": "static-1.6515",
  "crm-view-components": "static-1.955",
  "react-beautiful-dnd": "static-1.66",
  "customer-data-associations": "static-1.7561",
  "nudge-custom-function-registry": "static-1.2797",
  "nudge-renderer-utils": "static-1.3116",
  "whisper-core-api": "static-1.7187",
  "InboxConnectUtils": "static-4.15421",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46710",
  "hub-http-rxjs": "static-1.828",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4221",
  "company-details-components": "static-1.6431",
  "react-performance-metrics-lib": "static-1.784",
  "pricing-pages-ui-components": "static-1.15372",
  "quote-checkout-service-types": "static-1.3685",
  "social-insights-client-types": "static-1.22673",
  "crm_universal": "static-1.22397",
  "customer-data-email": "static-1.18425",
  "card-payment-highlight-lib": "static-1.37833",
  "card-subscription-highlight-lib": "static-1.40063",
  "commerce-contract-lib": "static-1.13100",
  "invoices-highlight-card-lib": "static-1.55476",
  "orders-highlight-card-lib": "static-1.22054",
  "products-highlight-card-lib": "static-1.18647",
  "quotes-highlight-card-lib": "static-1.72702",
  "crm-source-interpretation-lib": "static-1.5563",
  "crm-object-search-query-utilities": "static-1.10082",
  "utility-belt": "static-1.2762",
  "payments-enrollment-embed-lib": "static-1.23677",
  "stripe-embedded-components": "static-1.7897",
  "customer-data-rte": "static-1.33529",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6166",
  "payments-post-enroll-local-storage-lib": "static-1.5337",
  "qrcode-generator": "static-1.72",
  "quotes-client-types": "static-1.38792",
  "calling-orchestration-schema": "static-1.36600",
  "react-reducer-toolkit": "static-1.16232",
  "hub-http-contrib": "static-1.3269",
  "interframe": "static-3.4985",
  "tinymce-data": "static-1.41049",
  "ui-addon-sales-email": "static-1.5443",
  "layout-dnd-components": "static-1.12864",
  "layout-dnd-utils": "static-1.11839",
  "ui-brand-identity-lib": "static-1.16155",
  "NamespacedHubStyle": "static-2.9210",
  "meetings-connect-utils-lib": "static-1.7837",
  "access-control-lib": "static-1.10667",
  "EmailComponents": "static-1.55415",
  "EmailData": "static-1.54093",
  "redux-less": "static-2.9710",
  "company-details-service-types": "static-1.4169",
  "segments-query-core": "static-1.1653",
  "pricing-pages-api": "static-1.15237",
  "sequences-lib": "static-1.8423",
  "ui-gdpr-components": "static-1.10584",
  "products-ui-components": "static-1.40882",
  "accounting-integrations-ui-components": "static-1.7439",
  "invoices-ui-lib": "static-1.55492",
  "commerce-products-api": "static-1.2618",
  "invoices-iframe-lib": "static-1.57550",
  "quotes-modal-lib": "static-1.103380",
  "quotes-ui-lib": "static-1.81423",
  "stripe-connect-js": "static-1.74",
  "draft-content-plugins": "static-1.28793",
  "ContentData": "static-1.69094",
  "layout-data-lib": "static-1.10164",
  "ContentComponents": "static-2.71975",
  "marketing-contacts-lib": "static-1.10823",
  "marketing-email-service-types": "static-1.2060",
  "messaging-editing-lib": "static-1.46991",
  "messaging-usage-based-billing-components-lib": "static-1.1853",
  "automation-ui-source-apps": "static-1.19528",
  "automation-ui-types": "static-1.20446",
  "messaging-types-lib": "static-1.46728",
  "onboarding-settings-client": "static-1.4739",
  "sequences-client-types-lib": "static-1.8280",
  "commerce-tax-lib": "static-1.771",
  "price-books-api": "static-1.1585",
  "price-books-components": "static-1.1643",
  "property-description-translator": "static-1.4067",
  "ramp-editor": "static-1.764",
  "commerce-analytics-service-client": "static-1.3754",
  "totals-ui-components": "static-1.24174",
  "SalesContentIndexUI": "static-3.9546",
  "advanced-menus-core": "static-1.15489",
  "advanced-menus-lib": "static-1.12374",
  "ui-memberships-settings-lib": "static-1.34673",
  "automation-ui-ubb": "static-1.6362",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7564",
  "data-token-views": "static-1.16772",
  "forms-utils-lib": "static-1.12992",
  "payments-embed-points-lib": "static-1.13480",
  "simple-menus-core": "static-1.15488",
  "simple-menus-lib": "static-1.17005",
  "videoconference-integration-components": "static-1.7152",
  "marketing-contacts-client": "static-1.7737",
  "mc-hard-limits-client-types": "static-1.131",
  "automation-applications-service-types": "static-1.3637",
  "automation-platform-service-types": "static-1.2648",
  "ContentEditorUI": "static-2.77754",
  "short-messages-app-service-client": "static-1.4150",
  "web-interactives-components": "static-1.14148",
  "web-interactives-data": "static-1.14149",
  "messaging-shared-utils-lib": "static-1.1302",
  "messaging-user-info-utils-lib": "static-1.1472",
  "email-portal-health-service-types": "static-1.1208",
  "line-items-api": "static-1.1015",
  "commerce-totals-service-types": "static-1.3977",
  "FireAlarmUi": "static-1.4668",
  "sales-templates-service-types-lib": "static-1.4328",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22382",
  "automation-ui-usage-tracking": "static-1.21845",
  "data-studio-ubb": "static-1.3377",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27539",
  "content-management-data-lib": "static-1.5842",
  "copilot-plugins": "static-1.11681",
  "cta-picker": "static-1.36961",
  "customer-agent-discovery-components-lib": "static-1.3746",
  "editor-components": "static-1.13553",
  "editor-iframe-lib": "static-1.8711",
  "error-messaging-js": "static-1.5424",
  "FormsCommonComponents": "static-1.86448",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.68",
  "redux-request-state": "static-1.10879",
  "SharedLegalStrings": "static-1.1975",
  "smart-content-core": "static-1.43043",
  "smart-content-lib": "static-1.43696",
  "social-composer-lib": "static-1.60017",
  "structured-content-lib": "static-1.25788",
  "theme-previewer-lib": "static-1.53816",
  "tinymce-copilot": "static-1.17032",
  "xray-recommendation-lib": "static-1.8188",
  "automation-ui-routing": "static-1.21803",
  "sql-reporting-client-types": "static-1.5834",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42672",
  "campaigns-utils-lib": "static-1.3428",
  "reporting-enablement": "static-1.23672",
  "forms-ai-lib": "static-1.4664",
  "codemirror-dlb": "static-1.59313",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6669",
  "report-customization-components": "static-1.13763",
  "data-quality-ui-library": "static-1.13638",
  "reporting-filters": "static-1.878",
  "reporting-insights-lib": "static-1.2422"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13071",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "data-fetching-client": "/data-fetching-client/static-1.9887",
  "foundations-components": "/foundations-components/static-1.8357",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1382",
  "foundations-theming": "/foundations-theming/static-1.4683",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.85",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8255",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10495",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11711",
  "I18n": "/I18n/static-7.1655",
  "jasmine-runner": "/jasmine-runner/static-1.6678",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.519",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13134",
  "quartz": "/quartz/static-1.7340",
  "react-dlb": "/react-dlb/static-1.84",
  "react-rhumb": "/react-rhumb/static-1.16936",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3085",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10437",
  "reselect": "/reselect/static-3.8",
  "settings-ui-lib": "/settings-ui-lib/static-1.12750",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7531",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11376",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9763",
  "unified-auth": "/unified-auth/static-1.767",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1049",
  "usage-tracker": "/usage-tracker/static-1.7587",
  "usage-tracker-core": "/usage-tracker-core/static-1.7437",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8327",
  "hub-http": "/hub-http/static-1.6443",
  "integrations-lib": "/integrations-lib/static-1.16879",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20523",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.509",
  "property-management-iframe": "/property-management-iframe/static-1.13923",
  "quartz-config": "/quartz-config/static-1.1118",
  "quartz-core": "/quartz-core/static-1.6559",
  "quartz-routing": "/quartz-routing/static-1.770",
  "quick-fetch": "/quick-fetch/static-1.4077",
  "react": "/react/static-7.190",
  "rpc-client-utils": "/rpc-client-utils/static-1.4892",
  "ts-schema": "/ts-schema/static-1.4239",
  "ui-universal-auth": "/ui-universal-auth/static-1.9253",
  "UIComponents": "/UIComponents/static-3.8657",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3561",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3617",
  "quartz-webpack": "/quartz-webpack/static-1.3564",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.418",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4626",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5105",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2399",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-story-utils": "/hs-story-utils/static-1.9656",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.55",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5501",
  "react-virtualized": "/react-virtualized/static-2.103",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2413",
  "ui-fonts": "/ui-fonts/static-1.973",
  "ui-images": "/ui-images/static-2.1223",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3166",
  "foundations-theming-base": "/foundations-theming-base/static-1.3668",
  "stylex": "/stylex/static-1.37",
  "HeadJS": "/HeadJS/static-2.785",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3366",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4548",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8936",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9544",
  "ai-rendering-library": "/ai-rendering-library/static-1.10961",
  "chirp-fetch": "/chirp-fetch/static-1.2117",
  "connections-embed-lib": "/connections-embed-lib/static-1.1408",
  "copilot-toolkit": "/copilot-toolkit/static-1.11709",
  "feedback-loader": "/feedback-loader/static-1.29706",
  "laboratory-lib": "/laboratory-lib/static-3.7381",
  "marketplace-embed": "/marketplace-embed/static-1.22775",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10418",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20478",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14693",
  "sanitize-text": "/sanitize-text/static-1.8378",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6001",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5273",
  "wootric-nps": "/wootric-nps/static-1.7146",
  "quartz-head": "/quartz-head/static-1.1005",
  "web-vitals": "/web-vitals/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4887",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4381",
  "highcharts": "/highcharts/static-8.107",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2635",
  "reporting-data": "/reporting-data/static-1.68504",
  "cssUtils": "/cssUtils/static-1.862",
  "flux-actions": "/flux-actions/static-1.357",
  "HubStyle": "/HubStyle/static-2.12018",
  "PatternValidationJS": "/PatternValidationJS/static-1.3126",
  "react-colorpicker": "/react-colorpicker/static-2.10437",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.71",
  "ReduxMessenger": "/ReduxMessenger/static-2.10595",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7577",
  "icons": "/icons/static-2.672",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19055",
  "storybook-react": "/storybook-react/static-1.36",
  "trellis-story-utils": "/trellis-story-utils/static-1.4740",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5840",
  "quartz-i18n": "/quartz-i18n/static-1.1015",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.314",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.891",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.893",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1037",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.337",
  "slack-ui-library": "/slack-ui-library/static-1.10625",
  "fsm": "/fsm/static-1.3967",
  "customer-data-objects": "/customer-data-objects/static-1.7914",
  "property-translator": "/property-translator/static-1.5623",
  "hs-locale-management": "/hs-locale-management/static-1.241",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8158",
  "hs-promise-utils": "/hs-promise-utils/static-1.5825",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5107",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14294",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5838",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8007",
  "sanitize": "/sanitize/static-1.4706",
  "superstore": "/superstore/static-1.4986",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10492",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8229",
  "hub-http-janus": "/hub-http-janus/static-1.863",
  "hubspotter-http": "/hubspotter-http/static-1.4809",
  "immutable-less": "/immutable-less/static-1.4881",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17930",
  "nav-meta": "/nav-meta/static-1.30326",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18301",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.851",
  "ai-studio-lib": "/ai-studio-lib/static-1.12304",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18852",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.381",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9306",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8255",
  "ui-product-approvals": "/ui-product-approvals/static-1.28956",
  "ui-tool-access": "/ui-tool-access/static-1.10383",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4005",
  "property-management-common": "/property-management-common/static-1.6211",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.560",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1015",
  "quartz-test": "/quartz-test/static-1.1015",
  "quartz-tracking": "/quartz-tracking/static-1.719",
  "trellis-components": "/trellis-components/static-1.2432",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.302",
  "bender-build-tools": "/bender-build-tools/static-1.3356",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22543",
  "ContentUtils": "/ContentUtils/static-1.69019",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13261",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2727",
  "breeze-engine-core": "/breeze-engine-core/static-1.805",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.579",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40692",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13408",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15291",
  "ExportDialog": "/ExportDialog/static-6.10610",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41875",
  "reporting-snowflake": "/reporting-snowflake/static-1.57122",
  "reporting-ui-components": "/reporting-ui-components/static-2.65775",
  "reporting-visualizations": "/reporting-visualizations/static-1.60580",
  "trellis-theming": "/trellis-theming/static-1.1185",
  "ui-addon-teams": "/ui-addon-teams/static-1.21836",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.435",
  "magpie-lib": "/magpie-lib/static-1.5710",
  "navigation-components": "/navigation-components/static-1.18689",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1527",
  "magpie-types": "/magpie-types/static-1.5170",
  "simple-logging-lib": "/simple-logging-lib/static-1.3279",
  "fail-safe": "/fail-safe/static-1.180",
  "app-governance-lib": "/app-governance-lib/static-1.2254",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10728",
  "purchase-motions-components": "/purchase-motions-components/static-1.6263",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9930",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6004",
  "usage-tracker-public": "/usage-tracker-public/static-1.7398",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3931",
  "reference-resolvers": "/reference-resolvers/static-1.8412",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4150",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.566",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3240",
  "final-form": "/final-form/static-1.73",
  "redux-toolkit": "/redux-toolkit/static-1.73",
  "simple-data-table": "/simple-data-table/static-1.3405",
  "atom": "/atom/static-1.5306",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.98",
  "react-codemirror": "/react-codemirror/static-1.10870",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4986",
  "content-assistance-lib": "/content-assistance-lib/static-1.8107",
  "content-media-capture": "/content-media-capture/static-1.5245",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10056",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24314",
  "growth-payments-core": "/growth-payments-core/static-1.26035",
  "knowledge-content-types": "/knowledge-content-types/static-1.8614",
  "payment-link-components": "/payment-link-components/static-1.24044",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20209",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10116",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9311",
  "video-components-external": "/video-components-external/static-1.12008",
  "video-data-lib": "/video-data-lib/static-1.35666",
  "navigation-messaging": "/navigation-messaging/static-1.8016",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58566",
  "react-dnd-compat": "/react-dnd-compat/static-1.4845",
  "batch-promise": "/batch-promise/static-1.1774",
  "crm-component-utils": "/crm-component-utils/static-1.39698",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6119",
  "customer-data-properties": "/customer-data-properties/static-1.52374",
  "external-options-client-types": "/external-options-client-types/static-1.4286",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7123",
  "property-value-citations": "/property-value-citations/static-1.2988",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8329",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10493",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "cms-field-types": "/cms-field-types/static-1.5044",
  "content-icons-ui": "/content-icons-ui/static-1.2297",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.124",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.746",
  "pulse": "/pulse/static-1.854",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7479",
  "crm-message-bus": "/crm-message-bus/static-1.43593",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23127",
  "events-data-lib": "/events-data-lib/static-1.473",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4955",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4167",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7028",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1227",
  "onboarding-tours": "/onboarding-tours/static-1.17013",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14333",
  "academy-common-lib": "/academy-common-lib/static-1.14751",
  "dashboard-lib": "/dashboard-lib/static-1.82508",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19074",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18844",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8934",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11319",
  "user-context": "/user-context/static-1.5342",
  "reporting-plugins": "/reporting-plugins/static-1.10671",
  "reporting-reports": "/reporting-reports/static-1.68182",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.950",
  "nest": "/nest/static-1.467",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.505",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.131",
  "framework-listing-lib": "/framework-listing-lib/static-2.29335",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31276",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4484",
  "onboarding-scopes": "/onboarding-scopes/static-1.6688",
  "purchase-motions-api": "/purchase-motions-api/static-1.6266",
  "signup-constants": "/signup-constants/static-1.19456",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8288",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5227",
  "one-click-checkout": "/one-click-checkout/static-1.305",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7831",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15175",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3740",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9953",
  "redux-thunk": "/redux-thunk/static-2.75",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.74",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29178",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13049",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4654",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.570",
  "ui-addon-opt": "/ui-addon-opt/static-4.8592",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6508",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5310",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3766",
  "data-token-picker": "/data-token-picker/static-1.16791",
  "FileManagerLib": "/FileManagerLib/static-1.39954",
  "content-media-compositions": "/content-media-compositions/static-2.17056",
  "media-bridge-lib": "/media-bridge-lib/static-1.19311",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22534",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3363",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7098",
  "card-properties-lib": "/card-properties-lib/static-1.44866",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37640",
  "crm-actions": "/crm-actions/static-1.6580",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44329",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9822",
  "customer-data-tracking": "/customer-data-tracking/static-1.7112",
  "hs-resources": "/hs-resources/static-1.418",
  "calling-global-api": "/calling-global-api/static-1.65302",
  "calling-internal-common": "/calling-internal-common/static-1.31546",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66684",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58978",
  "commerce-products-lib": "/commerce-products-lib/static-1.10364",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3958",
  "crm-links": "/crm-links/static-1.6549",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4449",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4295",
  "formula-editor": "/formula-editor/static-1.14648",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4372",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.865",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3852",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49478",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4127",
  "smart-property-lib": "/smart-property-lib/static-1.8139",
  "tiered-pricing": "/tiered-pricing/static-1.1830",
  "topics-actions-lib": "/topics-actions-lib/static-1.388",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11216",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.242",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.357",
  "event-emitter": "/event-emitter/static-1.1182",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1495",
  "growth-data-modal": "/growth-data-modal/static-1.5792",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3291",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2558",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1079",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7873",
  "academy-service-client": "/academy-service-client/static-1.3920",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39813",
  "SafeStorage": "/SafeStorage/static-1.4633",
  "video-embed": "/video-embed/static-1.36500",
  "redux-actions": "/redux-actions/static-3.67",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24882",
  "viral-links-lib": "/viral-links-lib/static-1.7303",
  "nested-table": "/nested-table/static-1.464",
  "timezone-utils": "/timezone-utils/static-2.5476",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18192",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9946",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5556",
  "customer-data-views-management": "/customer-data-views-management/static-1.25905",
  "framework-data-table": "/framework-data-table/static-2.12415",
  "nudge-client-utils": "/nudge-client-utils/static-1.3040",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1393",
  "switchboard-lib": "/switchboard-lib/static-1.446",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1446",
  "app-users-service-client": "/app-users-service-client/static-1.5848",
  "app-users-service-types": "/app-users-service-types/static-1.5256",
  "mini-checkout-client": "/mini-checkout-client/static-1.27400",
  "onboarding-utils": "/onboarding-utils/static-1.5592",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2105",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29163",
  "checkout-sdk": "/checkout-sdk/static-3.24243",
  "payment-method-components": "/payment-method-components/static-1.7077",
  "touchless-buying-components": "/touchless-buying-components/static-1.6111",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3715",
  "edison-service-client-types": "/edison-service-client-types/static-1.619",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6812",
  "audio-components": "/audio-components/static-1.6249",
  "FileManagerImages": "/FileManagerImages/static-1.37465",
  "video-components": "/video-components/static-1.14010",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92700",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46610",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17710",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4491",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1672",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19901",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19098",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10926",
  "crm-fe-perf": "/crm-fe-perf/static-1.23129",
  "calling-error-reporting": "/calling-error-reporting/static-1.31553",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11269",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6769",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1823",
  "commerce-permissions": "/commerce-permissions/static-1.1006",
  "products-iframe-lib": "/products-iframe-lib/static-1.8463",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10877",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6671",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10578",
  "sales-views-client-types": "/sales-views-client-types/static-1.4487",
  "bark-lib": "/bark-lib/static-1.16735",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.546",
  "policy-lib": "/policy-lib/static-1.7023",
  "react-tinymce": "/react-tinymce/static-1.55838",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10641",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54964",
  "tinymce-plugins": "/tinymce-plugins/static-1.58078",
  "tinymce-themes": "/tinymce-themes/static-1.56934",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2362",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2586",
  "user-context-client": "/user-context-client/static-1.4754",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "urlinator": "/urlinator/static-1.4763",
  "outpost": "/outpost/static-1.4392",
  "draft-convert": "/draft-convert/static-2.76",
  "draft-extend": "/draft-extend/static-3.79",
  "draft-js": "/draft-js/static-5.81",
  "draft-plugins": "/draft-plugins/static-2.22058",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4075",
  "ts-utils-lib": "/ts-utils-lib/static-1.405",
  "crm-export-dialog": "/crm-export-dialog/static-1.6515",
  "crm-view-components": "/crm-view-components/static-1.955",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.66",
  "customer-data-associations": "/customer-data-associations/static-1.7561",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2797",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3116",
  "whisper-core-api": "/whisper-core-api/static-1.7187",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15421",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46710",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.828",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4221",
  "company-details-components": "/company-details-components/static-1.6431",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.784",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15372",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3685",
  "social-insights-client-types": "/social-insights-client-types/static-1.22673",
  "crm_universal": "/crm_universal/static-1.22397",
  "customer-data-email": "/customer-data-email/static-1.18425",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37833",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40063",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13100",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55476",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22054",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18647",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72702",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5563",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10082",
  "utility-belt": "/utility-belt/static-1.2762",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23677",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7897",
  "customer-data-rte": "/customer-data-rte/static-1.33529",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6166",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5337",
  "qrcode-generator": "/qrcode-generator/static-1.72",
  "quotes-client-types": "/quotes-client-types/static-1.38792",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36600",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16232",
  "hub-http-contrib": "/hub-http-contrib/static-1.3269",
  "interframe": "/interframe/static-3.4985",
  "tinymce-data": "/tinymce-data/static-1.41049",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5443",
  "layout-dnd-components": "/layout-dnd-components/static-1.12864",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11839",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16155",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9210",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7837",
  "access-control-lib": "/access-control-lib/static-1.10667",
  "EmailComponents": "/EmailComponents/static-1.55415",
  "EmailData": "/EmailData/static-1.54093",
  "redux-less": "/redux-less/static-2.9710",
  "company-details-service-types": "/company-details-service-types/static-1.4169",
  "segments-query-core": "/segments-query-core/static-1.1653",
  "pricing-pages-api": "/pricing-pages-api/static-1.15237",
  "sequences-lib": "/sequences-lib/static-1.8423",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10584",
  "products-ui-components": "/products-ui-components/static-1.40882",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7439",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55492",
  "commerce-products-api": "/commerce-products-api/static-1.2618",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57550",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103380",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81423",
  "stripe-connect-js": "/stripe-connect-js/static-1.74",
  "draft-content-plugins": "/draft-content-plugins/static-1.28793",
  "ContentData": "/ContentData/static-1.69094",
  "layout-data-lib": "/layout-data-lib/static-1.10164",
  "ContentComponents": "/ContentComponents/static-2.71975",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10823",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2060",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46991",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1853",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19528",
  "automation-ui-types": "/automation-ui-types/static-1.20446",
  "messaging-types-lib": "/messaging-types-lib/static-1.46728",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4739",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8280",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.771",
  "price-books-api": "/price-books-api/static-1.1585",
  "price-books-components": "/price-books-components/static-1.1643",
  "property-description-translator": "/property-description-translator/static-1.4067",
  "ramp-editor": "/ramp-editor/static-1.764",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3754",
  "totals-ui-components": "/totals-ui-components/static-1.24174",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9546",
  "advanced-menus-core": "/advanced-menus-core/static-1.15489",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12374",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34673",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6362",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7564",
  "data-token-views": "/data-token-views/static-1.16772",
  "forms-utils-lib": "/forms-utils-lib/static-1.12992",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13480",
  "simple-menus-core": "/simple-menus-core/static-1.15488",
  "simple-menus-lib": "/simple-menus-lib/static-1.17005",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7152",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7737",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.131",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3637",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2648",
  "ContentEditorUI": "/ContentEditorUI/static-2.77754",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4150",
  "web-interactives-components": "/web-interactives-components/static-1.14148",
  "web-interactives-data": "/web-interactives-data/static-1.14149",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1302",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1472",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1208",
  "line-items-api": "/line-items-api/static-1.1015",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3977",
  "FireAlarmUi": "/FireAlarmUi/static-1.4668",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4328",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22382",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21845",
  "data-studio-ubb": "/data-studio-ubb/static-1.3377",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27539",
  "content-management-data-lib": "/content-management-data-lib/static-1.5842",
  "copilot-plugins": "/copilot-plugins/static-1.11681",
  "cta-picker": "/cta-picker/static-1.36961",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3746",
  "editor-components": "/editor-components/static-1.13553",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8711",
  "error-messaging-js": "/error-messaging-js/static-1.5424",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86448",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.68",
  "redux-request-state": "/redux-request-state/static-1.10879",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1975",
  "smart-content-core": "/smart-content-core/static-1.43043",
  "smart-content-lib": "/smart-content-lib/static-1.43696",
  "social-composer-lib": "/social-composer-lib/static-1.60017",
  "structured-content-lib": "/structured-content-lib/static-1.25788",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53816",
  "tinymce-copilot": "/tinymce-copilot/static-1.17032",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8188",
  "automation-ui-routing": "/automation-ui-routing/static-1.21803",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5834",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42672",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3428",
  "reporting-enablement": "/reporting-enablement/static-1.23672",
  "forms-ai-lib": "/forms-ai-lib/static-1.4664",
  "codemirror-dlb": "/codemirror-dlb/static-1.59313",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6669",
  "report-customization-components": "/report-customization-components/static-1.13763",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13638",
  "reporting-filters": "/reporting-filters/static-1.878",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2422"
}
};
